import React, { useState, createContext, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';

/**
 *
 */
const ConfigContext = createContext();
const ConfigSetcontext = createContext();

const ConfigProvider = ({ children }) => {
  const [state, setState] = useState({
    menuVisible: true,
    config: null,
    requireConfigUpdate: false,
    status: null
  });

  const updateConfig = useCallback(config => {
    setState(s => ({
      ...s,
      ...config
    }));
  }, []);

  const forceConfigUpdate = useCallback(() => {
    setState(s => ({
      ...s,
      requireConfigUpdate: true
    }));
  }, []);

  const setContext = useMemo(() => ({ updateConfig, forceConfigUpdate }), [
    updateConfig,
    forceConfigUpdate
  ]);

  return (
    <ConfigContext.Provider value={state}>
      <ConfigSetcontext.Provider value={setContext}>
        {children}
      </ConfigSetcontext.Provider>
    </ConfigContext.Provider>
  );
};

ConfigProvider.propTypes = {
  children: PropTypes.node
};

export { ConfigContext, ConfigSetcontext, ConfigProvider };
